import type {FileDocumentResponse} from "@mytour/shared";
import {useState} from "react";
import {DocumentCardChrome} from "./DocumentCardChrome";
import {FileTileLightbox} from "./FileTileLightbox";

type Props = {
  doc: FileDocumentResponse;
  onResume?: (document: FileDocumentResponse) => void;
};

export function FileCard({doc, onResume}: Props) {
  const [open, setOpen] = useState(false);

  return (
    <DocumentCardChrome>
      <FileTileLightbox
        doc={doc}
        onResume={onResume}
        previewUrl={null}
        open={open}
        onToggle={() => setOpen((v) => !v)}
      />
    </DocumentCardChrome>
  );
}
